export default {
  USER_SIGN_OUT: '@AUTH/USER_SIGN_OUT',
} as const
